import { render, staticRenderFns } from "./KeyValue.vue?vue&type=template&id=3bbb98ea&scoped=true&"
import script from "./KeyValue.vue?vue&type=script&lang=ts&"
export * from "./KeyValue.vue?vue&type=script&lang=ts&"
import style0 from "./KeyValue.vue?vue&type=style&index=0&id=3bbb98ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbb98ea",
  null
  
)

export default component.exports